var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"tm-visual-sprite",class:{
    d: _vm.$props.showDim,
    se: _vm.$props.isSceneEdit,
  }},_vm._l((_vm.sprite),function(spriteRectangle,i){return _c('i',{key:i,style:(spriteRectangle.styleObj)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }